module.exports = __webpack_public_path__ + "img/retkeilyreitti_original.48f9c94d.png";